/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-var */
import AppConsts from './appconst';

declare const abp: any;

export function L(key: string, sourceName?: string): string {
  const localizationSourceName = AppConsts.localization.defaultLocalizationSourceName;
  return abp?.localization?.localize(key, sourceName || localizationSourceName);
}

export function isGranted(permissionName: string): boolean {
  return abp?.auth.isGranted(permissionName);
}

/** True when the user holds any of the given permissions (one name, or a list of them). */
export function isAnyGranted(permissions: string | string[]): boolean {
  return [permissions].flat().some((name) => abp?.auth.isGranted(name));
}

export function isDemoTenant(): boolean {
  return abp?.features?.isEnabled('App.DemoMode') === true;
}
